export const calculatedView = width => {
  let view = 'desktop'
  if (width < 1150) view = 'tablet'
  if (width < 850) view = 'mobile'

  return view
}
